var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 45,
    viewBox: "0 0 56 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7981 20.5747L51.4719 17.2485L48.1437 13.9215C47.269 13.1326 45.9548 13.1326 45.1669 13.9215L41.8389 17.2485L38.426 20.5747C37.726 21.4494 37.9887 22.0626 39.038 22.0626H42.9814C42.9814 30.643 36.0601 37.6468 27.4839 37.6468C23.1942 37.6468 19.2518 35.8965 16.45 33.0944L11.2856 38.26C15.4874 42.4618 21.0922 45 27.4839 45C40.1784 45 50.3346 34.67 50.3346 22.0626H54.0981C55.411 22.0626 55.5857 21.4494 54.7981 20.5747Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8024 24.2515C17.5892 23.5503 17.3268 22.7636 16.1874 22.7636H12.248C12.248 14.1833 19.1638 7.35503 27.7454 7.35503C32.0351 7.35503 35.9724 9.01677 38.7763 11.8185L43.9419 6.56619C39.9148 2.53823 34.1372 0 27.7454 0C15.138 0 4.89383 10.1559 4.89383 22.7636H1.12941C-0.0979754 22.7636 -0.360623 23.5503 0.51737 24.2515L3.84534 27.6665L7.17151 30.9936C7.95825 31.8683 9.35944 31.8683 10.0612 30.9936L13.5621 27.6665L16.8024 24.2515Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.d31304745cd9217ed97b1ea4e7fe37de.svg";
export { ForwardRef as ReactComponent };